import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { ZorroTableComponent } from '../custom-table/zorro-table.component';
import { NoDataComponent } from '../no-data/no-data.component';

@Component({
  selector: 'app-expandable-detailed-view',
  standalone: true,
  imports: [CommonModule, ZorroTableComponent, NzPaginationModule, NoDataComponent],
  templateUrl: './expandable-detailed-view.component.html',
  styleUrl: './expandable-detailed-view.component.scss',
})
export class ExpandableDetailedViewComponent {
  @Input() data: any = [];
  @Input() metricDisplayName: string = '';
  @Input() meta: any[] = [];
  @Input() viewId: string = '';

  expandedIndices = new Set<number>();
  pageIndex = 1;

  ngOnInit() {
    console.log(this.data);
  }

  get pageSize(): number {
    return this.meta?.[0]?.maxRows ?? 10;
  }

  get maxRows(): number {
    return this.pageSize;
  }

  /** Data key used to compute the affected count. Configured via meta[0].affectedCountKey. */
  get affectedCountKey(): string {
    return this.meta?.[0]?.affectedCountKey ?? 'affected_test_cases';
  }

  /** Display label shown next to the count. Configured via meta[0].affectedCountLabel. */
  get affectedCountLabel(): string {
    return this.meta?.[0]?.affectedCountLabel ?? 'Affected Test Case(s)';
  }

  get pagedData(): any[] {
    const start = (this.pageIndex - 1) * this.pageSize;
    return this.data.slice(start, start + this.pageSize);
  }

  get totalItems(): number {
    return this.data.length;
  }

  onPageIndexChange(page: number): void {
    this.pageIndex = page;
    this.expandedIndices.clear();
  }

  toggleRow(index: number, event?: Event): void {
    event?.stopPropagation();
    if (this.expandedIndices.has(index)) {
      this.expandedIndices.delete(index);
    } else {
      this.expandedIndices.add(index);
    }
  }

  isExpanded(index: number): boolean {
    return this.expandedIndices.has(index);
  }

  getStatusLabel(status: string): string {
    if (!status) return '';
    const s = status.toLowerCase().trim();
    if (s === 'open' || s === 'in progress' || s === 'fixed to be verified') return 'Open';
    if (s === 'closed' || s === 'fixed verified') return 'Closed';
    return status;
  }

  getStatusClass(status: string): string {
    const label = this.getStatusLabel(status);
    switch (label) {
      case 'Open': return 'badge-status-open';
      case 'Closed': return 'badge-status-closed';
      default: return 'badge-status-default';
    }
  }

  getSeverityClass(severity: string): string {
    switch (severity?.toLowerCase().trim()) {
      case 'critical': return 'badge-sev-critical';
      case 'high': return 'badge-sev-high';
      case 'medium': return 'badge-sev-medium';
      case 'low': return 'badge-sev-low';
      case 'minor': return 'badge-sev-minor';
      default: return 'badge-sev-default';
    }
  }

  getAffectedTestCases(item: any): string[] {
    if (!item.affected_test_cases) return [];
    if (Array.isArray(item.affected_test_cases)) return item.affected_test_cases;
    return item.affected_test_cases
      .split(',')
      .map((s: string) => s.trim())
      .filter(Boolean);
  }

  getAffectedCount(item: any): number {
    const val = item?.[this.affectedCountKey];
    if (!val) return 0;
    if (Array.isArray(val)) return val.length;
    return val.toString().split(',').map((s: string) => s.trim()).filter(Boolean).length;
  }

  capitalize(value: string): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

}